import { Leaf, Thermometer, Cloud, Snowflake } from 'lucide-react';

// Constants for average US life expectancy
export const MALE_LIFE_EXPECTANCY = 76.1;
export const FEMALE_LIFE_EXPECTANCY = 81.1;
export const WEEKS_IN_YEAR = 52;

// Define seasons of life with icons
export const SEASONS = [
  { name: "Spring", start: 0, end: 20, description: "Youth & Development", icon: Leaf, color: "green" },
  { name: "Summer", start: 21, end: 40, description: "Growth & Productivity", icon: Thermometer, color: "yellow" },
  { name: "Autumn", start: 41, end: 60, description: "Harvest & Reflection", icon: Cloud, color: "orange" },
  { name: "Winter", start: 61, end: 999, description: "Wisdom & Legacy", icon: Snowflake, color: "blue" }
];

// Constants for additional visualizations
export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR = 60;
export const DAYS_IN_YEAR = 365.25;
export const HEARTBEATS_PER_MINUTE = 70;
export const MEALS_PER_DAY = 3;
export const SLEEP_HOURS_PER_DAY = 8;
export const PAGES_IN_BOOK = 400;

// Function Health affiliate link
export const FUNCTION_HEALTH_AFFILIATE_LINK = 'https://my.functionhealth.com/signup?code=SCUELLAR11&_saasquatch=SCUELLAR11';